import { RevealingPointsComponent } from '@sapientpro/sapientpro-data-models';
import RevealingPoints from '../../components/RevealingPoints/RevealingPoints';

const FAQSection = ({ faq }: { faq: RevealingPointsComponent }) => (
  <RevealingPoints
    data={faq}
    actionButtonText='Ask a question'
    contactFormType='section'
  />
);

export default FAQSection;
